import { StrictMode } from 'react'
import { createRoot, type Root } from 'react-dom/client'
import App from './App'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root not found')

// bun --hot перезапускает модуль, а createRoot на том же узле дважды — ошибка.
const globalWithRoot = globalThis as typeof globalThis & { __multiplierRoot?: Root }
const root = globalWithRoot.__multiplierRoot ?? createRoot(container)
globalWithRoot.__multiplierRoot = root

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
